import React from 'react'
import { ReactComponent as ListIcon } from 'assets/icons/list.svg'
import s from './StatusRoadmap.module.scss'

const StatusRoadmapView = ({
	statuses = [],
	countsByStatus = {},
	totalCount = 0,
	isAllActive = true,
	toggleStatus,
	clearStatusFilters,
	isStatusActive,
}) => {
	const allInteractive = totalCount > 0

	return (
		<div className={s.wrap}>
			{allInteractive ? (
				<button
					type="button"
					className={`${s.btn} ${s.interactive} ${s.all} ${isAllActive ? s.allActive : ''}`.trim()}
					onClick={clearStatusFilters}
					aria-pressed={isAllActive}
				>
					<span className={s.leadIcon} aria-hidden="true">
						<ListIcon />
					</span>
					<span className={s.label}>All</span>
					<span className={s.count}>{totalCount}</span>
				</button>
			) : (
				<span
					className={`${s.btn} ${s.empty} ${s.all} ${isAllActive ? s.allActive : ''}`.trim()}
					aria-hidden="true"
				>
					<span className={s.leadIcon}>
						<ListIcon />
					</span>
					<span className={s.label}>All</span>
				</span>
			)}

			{statuses.map(item => {
				const active = isStatusActive?.(item.id)
				const count = countsByStatus[item.id] ?? 0
				const interactive = count > 0
				const className = `${s.btn} ${s.item} ${s[item.id]} ${active ? s.active : ''} ${interactive ? s.interactive : s.empty}`.trim()

				if (!interactive) {
					return (
						<span key={item.id} className={className} aria-hidden="true">
							<span className={s.dot} />
							<span className={s.label}>{item.label}</span>
						</span>
					)
				}

				return (
					<button
						key={item.id}
						type="button"
						className={className}
						onClick={() => toggleStatus?.(item.id)}
						aria-pressed={active}
					>
						<span className={s.dot} aria-hidden="true" />
						<span className={s.label}>{item.label}</span>
						<span className={s.count}>{count}</span>
					</button>
				)
			})}
		</div>
	)
}

export default StatusRoadmapView
